import moment from 'moment';

import {momentDefaultTZ} from "./time/time.utils";
import {getLanguage} from './language.utils';
import {highlightField} from './search';

const CURRENT_LANG = getLanguage();

const mod = angular.module('app.filters', [])

/**
 * Display time formatted with moment.
 * @param formatString {String} Moment formatting
 * @param lang {String} the language key to use (required for dynamic updates)
 */
.filter('moment', function() {
  return function(date, formatString) {
    if (date) {
      // Check if the date could already be a moment, this would be over 10x faster
      const oralDate = moment.isMoment(date) ? date : momentDefaultTZ(date);
      oralDate.locale(CURRENT_LANG);
      return oralDate.format(formatString);
    }
    else {
      return date;
    }
  };
})

/**
 * Custom localized time formatter close to moment llll but with short weekday and month.
 * @param date {Moment} moment date to format
 * @param lang {String} the language key to use (required for dynamic updates)
 */
.filter('shortenedLongMoment', function() {
  return function(date) {
    if (CURRENT_LANG === 'fi') {
      return date.format('dd D.M.YYYY [klo] HH.mm');
    }
    else if (CURRENT_LANG === 'sv') {
      return date.format('dd D.M.YYYY [kl] HH.mm');
    }
    else {
      return date.format('dd MM/DD/YYYY [at] HH.mm');
    }
  };
})


/**
 * After limit, do not display exact amount of times for a date
 */
.filter('dateOverlayString', function() {
  var limit = 10;
  return function(count) {
    return count > limit ? limit + "+" : count;
  };
})


/**
 * Display time formatted as "today/tomorrow etc. 16:00"
 * The filter expects a date which it converts to default timezone.
 *
 * @param formatString {String} Moment formatting
 * @param lang {String} the language key to use (required for dynamic updates)
 */
.filter('nearbyTimeFormat', function() {

  return function(date) {
    const localTime = momentDefaultTZ(date);
    return date ? localTime.calendar() : date;
  };
})



.filter("sanitize", function($sce) {
  return function (htmlCode) {
    return $sce.trustAsHtml(htmlCode);
  };
})

.filter("capitalizeFirst", function() {
  return function (string) {
    if (!!string && string.length > 0) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
  };
})


.filter('toId', function () {
  return function (item) {
    item = item.toLowerCase();
    item = item.replace(/[äå]/g, 'a');
    item = item.replace(/[ö]/g, 'o');
    item = item.replace(/[^a-zA-Z\-\d ]/g, '');
    return item.replace(/\s+/g, '-');
  };
})

/**
 * Print value or dash if value is not set
 */

.filter("valueOrDash", function() {
  return function (input) {
    return input ? input : '-';
  };
})

/**
 * Highlight a term that is searched with Fuse.js and contains a matches property
 */
.filter('highlightSearch', function ($sce) {
  return function (searcheable_obj, field) {
    // Highlight return value can contain HTML, so trust it
    return $sce.trustAsHtml(highlightField(searcheable_obj, field));
  }
})

/**
 *  Join a string list with the delimiter with "comma space" as default.
 */
.filter('joinString', function () {
  return function (input, delimiter) {
    return (input || []).join(delimiter || ', ');
  }
})
;

export default mod.name;
